import React from 'react'
import { observer, inject } from 'mobx-react'
import { Helmet } from 'react-helmet'
import * as linkConst from '../../constants/link_constants'

import Archive from '../archive/list'
import Artist from '../artists/list'
import CReports from '../creports/list'
import Client from '../clients/list'
import Contract from '../contracts/list'
import ContractTimeRest from '../contract_time_restrictions/list'
import EnumsSet from '../enums_settings/list'
import FPVCategories from '../fpv_categories/list'
import FPVSetting from '../fpv_settings/list'
import FPVTesting from '../fpv_testing/list'
import FilmCargoHelp from '../filmcargo_help/list'
import Films from '../films/list'
import FinancialReports from '../financial_reports/list'
import Pricing from '../pricings/list'
import Rating from '../rating/list'
import Rights from '../rights/list'
import VATrates from '../vatrates/list'
import XRates from '../xrates/list'
import PPRollsSetup from '../pprolls/list'
import PPRollsUpload from '../uploading/list'
import YTAssets from '../youtube_assets/list'

const EntityList = ({ store }) => {
  const entityname = store.router.params.entityname
  switch (entityname) {
  case linkConst.LINK_ARCHIVE:
    return <section><Helmet title={store.__(linkConst.LINK_ARCHIVE_TITLE)} /><Archive store={store} /></section>
  case linkConst.LINK_CLIENTS:
    return <section><Helmet title={store.__(linkConst.LINK_CLIENTS_TITLE)} /><Client store={store} /></section>
  case linkConst.LINK_CONTRACT_TIME_RESTRICTIONS:
    return <section><Helmet title={store.__(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS_TITLE)} /><ContractTimeRest store={store} /></section>
  case linkConst.LINK_CONTRACTS:
    return <section><Helmet title={store.__(linkConst.LINK_CONTRACTS_TITLE)} /><Contract store={store} /></section>
  case linkConst.LINK_CATEG_SETTINGS:
    return <section><Helmet title={store.__(linkConst.LINK_CATEG_SETTINGS_TITLE)} /><EnumsSet store={store} /></section>
  case linkConst.LINK_FILMCARGO_HELP:
    return <section><Helmet title={store.__(linkConst.LINK_FILMCARGO_HELP_TITLE)} /><FilmCargoHelp store={store} /></section>
  case linkConst.LINK_FILMS:
    return <section><Helmet title={store.__(linkConst.LINK_FILMS_TITLE)} /><Films store={store} /></section>
  case linkConst.LINK_FINANCIAL_REPORTS:
    return <section><Helmet title={store.__(linkConst.LINK_FINANCIAL_REPORTS_TITLE)} /><FinancialReports store={store} /></section>
  case linkConst.LINK_CATEGORIES:
    return <section><Helmet title={store.__(linkConst.LINK_CATEGORIES_TITLE)} /><FPVCategories store={store} /></section>
  case linkConst.LINK_SETTINGS:
    return <section><Helmet title={store.__(linkConst.LINK_SETTINGS_TITLE)} /><FPVSetting store={store} /></section>
  case linkConst.LINK_PRICING:
    return <section><Helmet title={store.__(linkConst.LINK_PRICING_TITLE)} /><Pricing store={store} /></section>
  case linkConst.LINK_FPVTESTING:
    return <section><Helmet title={store.__(linkConst.LINK_FPVTESTING_TITLE)} /><FPVTesting store={store} /></section>
  case linkConst.LINK_PERSONS:
    return <section><Helmet title={store.__(linkConst.LINK_PERSONS_TITLE)} /><Artist store={store} /></section>
  case linkConst.LINK_PPROLLS_SETUP:
    return <section><Helmet title={store.__(linkConst.LINK_PPROLLS_SETUP_TITLE)} /><PPRollsSetup store={store} /></section>
  case linkConst.LINK_PPROLLS_UPLOAD:
    return <section><Helmet title={store.__(linkConst.LINK_PPROLLS_UPLOAD_TITLE)} /><PPRollsUpload store={store} /></section>
  case linkConst.LINK_RATING:
    return <section><Helmet title={store.__(linkConst.LINK_RATING_TITLE)} /><Rating store={store} /></section>
  case linkConst.LINK_REPORTS:
    return <section><Helmet title={store.__(linkConst.LINK_REPORTS_TITLE)} /><CReports store={store} /></section>
  case linkConst.LINK_RIGHTS:
    return <section><Helmet title={store.__(linkConst.LINK_RIGHTS_TITLE)} /><Rights store={store} /></section>
  case linkConst.LINK_TIERS_SETTINGS:
    return <section><Helmet title={store.__(linkConst.LINK_TIERS_SETTINGS_TITLE)} /><EnumsSet store={store} /></section>
  case linkConst.LINK_VATRATES:
    return <section><Helmet title={store.__(linkConst.LINK_VATRATES_TITLE)} /><VATrates store={store} /></section>
  case linkConst.LINK_XRATES:
    return <section><Helmet title={store.__(linkConst.LINK_XRATES_TITLE)} /><XRates store={store} /></section>
  case linkConst.LINK_YOUTUBE_ASSETS:
    return <section><Helmet title={store.__(linkConst.LINK_YOUTUBE_ASSETS_TITLE)} /><YTAssets store={store} /></section>
  }
  return null
// throw new Error('Invalid entity name to render: ' + entityname)
}

export default inject('store')(observer(EntityList))
